import React, { useEffect, useRef, useState } from 'react';
import './landing-page.preview.container.sass';
import { PreviewHeader } from '../../components/preview-header/preview-header';
import { PreviewDisco } from '../../components/preview-disco/preview-disco';
import {
    RainbowDivider,
    RainbowDividerSideColors,
    RainbowDividerTheme
} from '../../components/rainbow-divider/rainbow-divider';
import { PreviewKeepUp } from '../../components/preview-keep-up/preview-keep-up';
import { PreviewFooter } from '../../components/preview-footer/preview-footer';
import { PreviewInfo } from '../../components/preview-info/preview-info';
import { PreviewSteps } from '../../components/preview-steps/preview-steps';
import { PreviewEvent } from '../../components/preview-event/preview-event';
import axios from 'axios';
import { useParams } from 'react-router-dom';

export const LandingPagePreviewContainer = () => {

    const [event, setEvent] = useState(null);
    const { eventId } = useParams();

    const getEvent = (id) => {
        axios.request({method: 'GET', url: `https://api.viceversa.app/api/v1/event/${id}`})
            .then((data) => {
                setEvent(data.data);
            });
    };

    useEffect(() => {
        if (eventId) {
            getEvent(eventId);
        }
    }, []);

    const scrollRef = useRef(null);

    return (
        <div className='vv-landing-page-preview'>
            <PreviewHeader/>
            {
                event ?
                    <PreviewEvent event={event} scrollRef={scrollRef}/>
                    :
                    null
            }
            <PreviewDisco/>
            <PreviewInfo/>
            <RainbowDivider theme={RainbowDividerTheme.DARK} leftColor={RainbowDividerSideColors.lightGray} rightColor={RainbowDividerSideColors.black}/>
            <PreviewSteps/>
            {/*<RainbowDivider/>*/}
            {/*<PreviewRoadmap/>*/}
            <RainbowDivider theme={RainbowDividerTheme.DARK} leftColor={RainbowDividerSideColors.lightGray} rightColor={RainbowDividerSideColors.black}/>
            {/*<PreviewDownload scrollRef={scrollRef}/>*/}
            <PreviewKeepUp/>
            <PreviewFooter/>
        </div>
    );
};
